const React = require('react');
const T = require('prop-types');

const internals = {};

// eslint-disable-next-line react/display-name
const Emoji = React.memo(({ label, symbol, size, ...rest }) => {

    return (
        <span
            aria-label={label}
            role='img'
            {...rest}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: 1,
                ...(rest.style || {})
            }}
        >
            <span style={{ display: 'block', fontSize: size || 'inherit', lineHeight: 1 }}>{symbol}</span>
        </span>
    );
});

Emoji.propTypes = {
    label: T.string,
    symbol: T.string.isRequired
};

module.exports = Emoji;
